import { render } from "./ProductReturnForm.vue?vue&type=template&id=4dafd5cc"
import script from "./ProductReturnForm.vue?vue&type=script&lang=js"
export * from "./ProductReturnForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__